import React from 'react';
import { Controller } from 'react-hook-form';
import { FormCheckbox as FormCheckboxStyled, FormCheckboxText, FormCheckboxLink } from './style';

export interface IAppFormCheckboxProps {
  name: string
  control: any
  error?: boolean
}

export function AppFormCheckbox({ name, control, error }: IAppFormCheckboxProps) {
  return (
    <FormCheckboxStyled>
      <Controller
        control={control}
        rules={{ required: true }}
        name={name}
        render={({ field }) => (
          <>
            <input
              {...field}
              type="checkbox"
              name={name}
              id={name}
              checked={field.value || false}
              onChange={(e) => {
                field.onChange(e.target.checked);
              }}
            />
            <div className="checkmark" />
          </>
        )}
      />
      <FormCheckboxText>
        Нажимая на кнопку ниже, я даю
        {' '}
        <FormCheckboxLink href="https://petrovich.ru/about/soglasie/?utm_referrer=https%3a%2f%2fpetrovich.ru%2f%2fabout%2fsoglasie%2f" target="_blank" rel="noopener noreferrer">
          согласие на обработку персональных данных
        </FormCheckboxLink>
        {' '}
        в соответствии с
        {' '}
        <FormCheckboxLink href="https://petrovich.ru/about/confidentiality/" target="_blank" rel="noopener noreferrer">
          Политикой оператора
        </FormCheckboxLink>
      </FormCheckboxText>
      {error && (
        <div style={{
          fontWeight: 500,
          lineHeight: '16px',
          fontSize: '12px',
          color: '#ed1c24',
          marginTop: '5px',
          width: '100%',
        }}
        >
          Необходимо дать согласие на обработку персональных данных
        </div>
      )}
    </FormCheckboxStyled>
  );
}

AppFormCheckbox.defaultProps = {
  error: false,
};
